export var version = '3.7.17';
//# sourceMappingURL=version.js.map